import { render } from "./units.vue?vue&type=template&id=087c4b46&scoped=true"
import script from "./units.vue?vue&type=script&lang=js"
export * from "./units.vue?vue&type=script&lang=js"

import "./units.vue?vue&type=style&index=0&id=087c4b46&lang=scss"
import "./units.vue?vue&type=style&index=1&id=087c4b46&lang=scss"
import "./units.vue?vue&type=style&index=2&id=087c4b46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087c4b46"]])

export default __exports__